<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/partnership-compliance.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">
				Partnerships to Re-<br class="d-none d-sm-block" />Imagine
				Compliance
			</h1>
			<p class="shift-compliance-para mt-4">
				Join the RegOps movement to shift left
				<br class="d-none d-sm-block" />
				compliance.
			</p>
		</div>
	</div>
</div>
